import * as yup from "yup";

import * as RHFReviewValidationRules from "@/utils/validation/schemas/reviews.RHF";
import * as userValidationRules from "@/utils/validation/schemas/user.RHF";

export enum SwitchSteps {
    NO = "NO",
    NO_FEEDBACK = "NO_FEEDBACK",
    YES = "YES"
}

export const MAX_RATING = 5;
export const MIN_RATING = 1;
export const MAX_FILE_UPLOADS = 6;
// Max upload size: https://developers.bazaarvoice.com/v1.0-ConversationsAPI/docs/photo-upload
export const MAX_FILE_UPLOAD_SIZE_MEGABYTES = 30;
export const MAX_FILE_UPLOAD_SIZE_BYTES =
    MAX_FILE_UPLOAD_SIZE_MEGABYTES * 1024 * 1024;

const WriteReviewValidationSchema = yup.object({
    text: RHFReviewValidationRules.text,
    title: RHFReviewValidationRules.title,
    agreedToTermsAndConditions: RHFReviewValidationRules.terms,
    rating: RHFReviewValidationRules.rating(MIN_RATING, MAX_RATING),
    isRecommended: yup.mixed<SwitchSteps>().oneOf(Object.values(SwitchSteps)),
    ratingQuality: RHFReviewValidationRules.optionalRating(
        MIN_RATING,
        MAX_RATING
    ),
    ratingValue: RHFReviewValidationRules.optionalRating(
        MIN_RATING,
        MAX_RATING
    ),
    brandScore: RHFReviewValidationRules.brandScore,
    brandComment: RHFReviewValidationRules.brandComment,
    photos: RHFReviewValidationRules.photos(MAX_FILE_UPLOADS)
});

export const WriteInitialReviewValidationSchema = yup
    .object({
        nickname: RHFReviewValidationRules.nickname,
        email: userValidationRules.emailWithNB
    })
    .concat(WriteReviewValidationSchema);

export const WriteProgressiveReviewValidationSchema = yup
    .object({
        nickname: yup.string().optional(),
        email: yup.string().optional()
    })
    .concat(WriteReviewValidationSchema);

export type WriteInitialReviewFormValues = yup.InferType<
    typeof WriteInitialReviewValidationSchema
>;

export type WriteProgressiveReviewFormValues = yup.InferType<
    typeof WriteProgressiveReviewValidationSchema
>;
